<template>
    <v-app-bar
        app
        fixed
        :height="$vuetify.breakpoint.lgAndUp ? 188 : 218"
        elevation="0"
        class="app-top-bar"
        :style="{ padding: $vuetify.breakpoint.lgAndUp ? '0' : '0px 16px 0 16px' }"
        :class="{ mobile: $vuetify.breakpoint.mdAndDown }"
    >
        <div class="full-width">
            <div class="app-top-bar-content">
                <v-img :src="require('@/assets/autoCity72logo.svg')" :max-width="$vuetify.breakpoint.lgAndUp ? 156 : 124" class="logo" />

                <v-toolbar-title v-if="$vuetify.breakpoint.lgAndUp">
                    <div class="d-flex">
                        <v-img :src="require('@/assets/MapPin.png')" max-width="20" class="mr-1" />
                        <span class="current-city-title">Тюмень</span>
                    </div>
                </v-toolbar-title>

                <v-spacer />

                <div class="app-bar-contact">
                    <div class="phone"><a href="tel:+78001008332">8 (800) 100-83-32</a></div>
                    <div class="caption">Бесплатный звонок</div>
                </div>
            </div>

            <TopMenuBar v-if="showTopMenu" />
            <TopInternalBar v-else />
        </div>
    </v-app-bar>
</template>

<script>
    import { mapState } from 'vuex'
    import TopMenuBar from '@/components/Vuetify/TopMenuBar'
    import TopInternalBar from '@/components/Vuetify/TopInternalBar'

    export default {
        name: 'AppBar',

        components: {
            TopMenuBar,
            TopInternalBar,
        },

        data: () => ({
            loading: true,
        }),

        computed: {
            ...mapState('ui', {
                navigationDrawerState: state => state.navigationDrawer,
            }),

            ...mapState('ui', {
                appBarState: state => state.appBar,
            }),

            title() {
                return this.appBarState.title
            },

            showTopMenu() {
                return this.$route.meta?.showTopMenu
            },

            navigationIcon() {
                let navigationIcon = this.appBarState.navigationIcon

                if (navigationIcon) {
                    switch (navigationIcon.type) {
                        case 'nav':
                            if (this.$vuetify.breakpoint.mdAndDown) {
                                navigationIcon.icon = 'bars'
                                navigationIcon.click = () => this.$store.commit('ui/setNavigationDrawer', {
                                    isShown: !this.navigationDrawerState.isShown,
                                })
                            } else {
                                navigationIcon = null
                            }
                            break
                        case 'back':
                            navigationIcon.icon = 'arrowLeft'
                            if (!navigationIcon.click) {
                                navigationIcon.click = () => this.$router.back()
                            }
                            break
                    }
                }

                return navigationIcon
            },

            progress() {
                return this.appBarState.progress
            },
        },
    }
</script>

<style>
    .v-app-bar {
        max-width: 1280px;
        width: 100%;
        margin: auto;
        background-color: #F3F3F3 !important;
        top: 1px !important;
    }
    .v-app-bar .v-toolbar__content {
        padding: 0 !important;
        padding-top: 30px !important;
        align-items: start;
    }
    .app-top-bar-content {
        display: flex !important;
        align-items: center;
        width: 100%;
    }
    .logo {
        margin-right: 25px;
    }
    .current-city-title {
        font-size: 14px;
        font-weight: 600;
    }
    .app-bar-contact .phone {
        color: #36393B;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
    }
    .app-bar-contact .phone a{
        color: #36393B;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        text-decoration: none;
    }
    .app-bar-contact .caption {
        color: #8F8F8F;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        text-align: center;
    }
    .full-width {
        width: 100%;
    }
</style>
